// 按需改成你的后端地址
export const BASE_URL =
  process.env.VUE_APP_API_BASE_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://127.0.0.1:8088')

// 后端未就绪时，设为 true 使用内置 Mock（可先跑通前端流程）
export const USE_MOCK = false
